module.exports = __webpack_public_path__ + "static/media/cockroach(27).f1a8fb5c.PNG";